import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export default function AuthHashHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check for hash in URL (for auth callbacks like email verification and password resets)
    const handleAuthHashChange = async () => {
      const hash = window.location.hash;
      
      if (hash && hash.includes("access_token")) {
        try {
          // Extract tokens from hash
          const params = new URLSearchParams(hash.substring(1));
          const accessToken = params.get("access_token");
          const refreshToken = params.get("refresh_token");
          const type = params.get("type");
          
          if (accessToken && refreshToken) {
            // Set the session with the tokens
            const { error } = await supabase.auth.setSession({
              access_token: accessToken,
              refresh_token: refreshToken,
            });
            
            if (error) throw error;
            
            // Clean up URL by replacing hash
            window.history.replaceState(null, "", window.location.pathname);
            
            // Show appropriate message based on auth type
            if (type === "signup") {
              toast.success("Email verified successfully!");
              navigate("/dashboard");
            } else if (type === "recovery") {
              // Don't show success message yet - user still needs to enter new password
              navigate("/reset-password");
            } else {
              toast.success("Authentication successful!");
              navigate("/dashboard");
            }
          }
        } catch (error: any) {
          console.error("Error processing authentication:", error);
          toast.error("Authentication error: " + (error.message || "Unknown error"));
        }
      }
    };
    
    handleAuthHashChange();
  }, [navigate, location]);
  
  return null; // This component doesn't render anything
}
